module.exports = __webpack_public_path__ + "img/chart.7d30f589.svg";